<template>
    <div>
        <div class="container">
            <div class="row align-items-center py-4">
                <div class="col-6 col-lg-3">
                    <a href="https://www.northwestcareercollege.edu" class="app-logo">
                        <img src="/img/brand-logo.svg" alt="">
                    </a>
                </div>
                <div class="col-12 col-lg-6 order-3 order-lg-2">
                    <div class="text-brand text-center h4 mb-0 header-title">
                        Records Request Portal
                    </div>
                </div>
                <div class="col-6 col-lg-3 order-2 order-lg-3">
                    <div class="text-end">
                        <h6 class="mb-0">Having trouble?</h6>
                        <a href="tel:702-254-7577" class="link-hover-underline">
                            <h5 class="mb-0">702-254-7577</h5>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header'
}
</script>
